import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader, Spinner, EmptyState } from "@/components/common";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { RankingComparison, CriterionComparison, CategoryPriorityComparison } from "./ResultsView";
import { cn } from "@/lib/utils";

export function StudyResults({ studyId }) {
  const [data, setData] = useState(null);
  useEffect(() => { setData(null); api.get(`/admin/studies/${studyId}/results`).then((r) => setData(r.data)); }, [studyId]);
  if (!data) return <Spinner />;
  return (
    <Tabs defaultValue="ranking">
      <TabsList className="mb-6 rounded-full bg-plena-surface2 p-1">
        <TabsTrigger value="ranking" data-testid="results-tab-ranking" className="rounded-full">Sıralama Karşılaştırması</TabsTrigger>
        <TabsTrigger value="criteria" data-testid="results-tab-criteria" className="rounded-full">Kategori Puanları</TabsTrigger>
        <TabsTrigger value="priority" data-testid="results-tab-priority" className="rounded-full">Kategori Önceliği</TabsTrigger>
      </TabsList>
      <TabsContent value="ranking"><RankingComparison data={data} /></TabsContent>
      <TabsContent value="criteria"><CriterionComparison data={data} /></TabsContent>
      <TabsContent value="priority"><CategoryPriorityComparison data={data} /></TabsContent>
    </Tabs>
  );
}

export default function ResultsPage() {
  const [studies, setStudies] = useState(null);
  const [params, setParams] = useSearchParams();
  useEffect(() => { api.get("/admin/studies").then((r) => setStudies(r.data.filter((s) => s.status !== "DRAFT"))); }, []);
  if (!studies) return <Spinner />;
  const sid = params.get("study") || studies[0]?.id;
  return (
    <div className="fade-up">
      <PageHeader eyebrow="Sonuçlar" title="Değerlendirici sonuçları" description="Yalnızca yöneticiler görebilir. Her uzmanın ham kararları bağımsız olarak gösterilir." />
      {!studies.length ? <EmptyState testId="results-empty" title="Henüz başlatılmış değerlendirme yok" /> : (
        <div className="space-y-6">
          <div className="flex flex-wrap gap-2" data-testid="results-study-picker">
            {studies.map((s) => <button key={s.id} data-testid={`results-study-${s.id}`} onClick={() => setParams({ study: s.id })} className={cn("rounded-full border px-4 py-1.5 text-sm transition-colors duration-150", s.id === sid ? "border-plena-text bg-plena-text text-white" : "border-plena-border bg-white hover:border-[#C9CDD6]")}>{s.title}</button>)}
          </div>
          <StudyResults studyId={sid} />
        </div>
      )}
    </div>
  );
}
